<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Pending FWA List</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="text-center action-column">Action</th>
                <th>Employee ID</th>
                <th>Employee Name</th>
                <th>1st Level Approver</th>
                <th>2nd Level Approver</th>
                <th>FWA Type</th>
                <th>FWA Start Date</th>
                <th>FWA End Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in records" :key="item.Id">
                <td class="action-column text-center">
                  <!-- <router-link
                    :to="{
                      name: 'fwaView',
                      params: { id: item.Id },
                    }"
                  >
                    <a class="btn btn-secondary"><span>View</span></a>
                  </router-link> -->
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="view(item.Id)"
                  >
                    View
                  </button>
                </td>
                <td>{{ item.EmployeeID }}</td>
                <td>{{ item.EmployeeName }}</td>
                <td>
                  {{
                    item.FirstLevelApproverEmployeeName &&
                    item.FirstLevelApproverEmployeeID
                      ? `${item.FirstLevelApproverEmployeeName} (${item.FirstLevelApproverEmployeeID})`
                      : ""
                  }}
                </td>
                <td>
                  {{
                    item.SecondLevelApproverEmployeeName &&
                    item.SecondLevelApproverEmployeeID
                      ? `${item.SecondLevelApproverEmployeeName} (${item.SecondLevelApproverEmployeeID})`
                      : ""
                  }}
                </td>
                <td>{{ item.Type }}</td>
                <td>{{ item.StartDateDisplay }}</td>
                <td>{{ item.EndDateDisplay }}</td>
                <td>{{ item.Status }}</td>
              </tr>
              <tr v-if="records && !records.length">
                <td colspan="9" class="text-center">{{ noRecordText }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      records: [],
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
  },
  methods: {
    view(fwaId) {
      this.$store.state.fwaSourcePage = "Pending FWA List";
      this.$router.push({ name: "fwaView", params: { id: fwaId } });
    },
    getManagerFwaPendingList() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getManagerFwaPendingList(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.records = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.message, { icon: "error" });
        });
    },
  },
  created() {
    this.getManagerFwaPendingList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Fwa/PendingList.vue